import React from 'react';

/** Big-number data display — the brand's "data is a flex" moment. */
export default function StatTile({ value, suffix, label, caption, tone = 'ink', align = 'left', style, ...rest }) {
  const accent = tone === 'science' ? 'var(--science-500)' : tone === 'human' ? 'var(--human-500)' : 'var(--ink)';
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', gap: 4, textAlign: align,
      alignItems: align === 'center' ? 'center' : 'flex-start', ...style,
    }} {...rest}>
      {label && (
        <span style={{
          fontFamily: 'var(--font-sans)', fontWeight: 'var(--w-medium)', fontSize: 'var(--text-xs)',
          letterSpacing: 'var(--track-eyebrow)', textTransform: 'uppercase', color: 'var(--ink-muted)',
        }}>{label}</span>
      )}
      <span style={{
        display: 'inline-flex', alignItems: 'baseline', gap: 2,
        fontFamily: 'var(--font-display)', fontWeight: 'var(--w-bold)',
        letterSpacing: 'var(--track-display)', lineHeight: 1, color: accent,
      }}>
        <span style={{ fontSize: 'var(--text-display-xl)' }}>{value}</span>
        {suffix && <span style={{ fontSize: 'var(--text-h1)', fontWeight: 'var(--w-medium)' }}>{suffix}</span>}
      </span>
      {caption && (
        <span style={{
          fontFamily: 'var(--font-serif)', fontSize: 'var(--text-sm)', color: 'var(--ink-soft)',
          lineHeight: 'var(--lh-snug)', maxWidth: '28ch',
        }}>{caption}</span>
      )}
    </div>
  );
}
